import React, { useContext } from 'react';
import SchoolCost from '../SchoolCost';
import SchoolItemContext from '../SchoolItemContext';

const SchoolItemCost = () => {
  const { school } = useContext(SchoolItemContext);
  const { cost } = school || {};
  return (
    <div className="school-item__cost">
      <SchoolCost cost={cost} />
    </div>
  );
};

export default SchoolItemCost;
